import React from 'react';
import './ProgramNewPage.css';
import Container from '../components/Container';
import '../styles/generics.css'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import PageComponent from '../components/PageComponent';
import Labels from '../Labels';
import Connection from '../config/Connection';
import { Modal, Button, InputGroup, Form, Dropdown, DropdownButton, FormControl, Tabs, Tab, ButtonGroup } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import Parsers from '../Tools/Parsers';
import GenericHelper from '../Tools/GenericHelper';
import CompanyPage from './CompanyPage';
import MaskedInput from '../components/MaskedInput';
import AdminPage from './AdminPage';
import ProgramDetailPage from './ProgramDetailPage';
import ProgramGoalPage from './ProgramGoalPage';
import ErrorComponent from '../components/ErrorComponent';


const defaultInvoice = {
  accountAgency: "",
  accountBank: "",
  accountNumber: "",
  accountType: "",
  criticalValue: null,
  datetimeEmission: null,
  indentificator: null,
  issuer: null,
  kind: null,
  series: null,
  title: null,
  valueTotal: null,
  invoiceType: null,
  mainKeyCriticalType: null
};

export default class ProgramGoalActionPlanPage extends PageComponent {
  static PageInfo = {

    path: "/Program/Detail/:id/Goal/:goal/ActionPlan/:action",
    parent: ProgramGoalPage,
    name: "menu.qualitativeaward",
    permission: { "ACTION_PLAN_ACCESSING": true },
    icon: "money-bill-wave",
    hidden: true
  }

  constructor(props) {
    super(props);
    this.data = props.match.params;
    this.state.data = null;
    this.state.loading = true;
    this.state.modalInitializing = false;
    this.state.modalLoading = false;
    this.state.costumerLoading = false;
    this.state.isModalVisible = null;
    this.state.modalError = null;
    this.state.selectedType = null;
    this.state.selectedBrand = null;
    this.state.changed = false;
    this.state.label = null;
    this.state.goal = null;
    this.state.selectionType = "name";
    this.state.filter = "";
    this.state.doc = null;
    this.state.region = null;
    this.state.city = null;
    this.state.name = null;
    this.state.selectedClient = null;
    this.state.form = null;
    this.state.tabmode = "home";
    this.state.hierarchy = null;
    this.state.productGroupDevolutionId = null;
    this.state.fkClientType = null;
    this.state.datetimeRegister = null;
    this.state.promotionalBudgetTypeId = null;
  }

  componentDidMount() {

    Connection.Secure(Connection.service + 'Program/' + this.data.id + "/Client/" + this.data.goal + "/Award/Action/" + this.data.action)
      .then((response) => {
        if (response.ok && response.status == 200)
          response.json().then((data) => {
            setTimeout(() => this.setState({ data: data, loading: false, status: data.qaActionPlanStatusElement[0] }));
          });
        else this.setState({ error: response, loading: false });
      })
      .catch((error) => {
        this.setState({ error: error, loading: false });
      });
  }

  parseDate(t) {
    t = t.split('/');
    return t[2] + "-" + t[1] + "-" + t[0] + "T00:00:00";
  }

  saveGoal(t) {
    this.setState({ modalLoading: true });
    Connection.Secure(Connection.service + 'Program/' + this.data.id + "/Client/" + this.data.goal + "/Award/Action/" + this.data.action,
      {
        "method": "PUT",
        "headers": {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(t)
      })
      .then((response) => {
        if (response.ok && response.status == 200) {
          response.json().then(st => {
            GenericHelper.copyProperties(t, this.state.data);
            this.state.data.valueTotal = t.valueUnitary * t.amount;
            this.setState({ modalLoading: false, isModalVisible: null, data: this.state.data, status: st });
          });
        }
        else this.setState({ modalError: response, modalLoading: false });
      })
      .catch((error) => {
        this.setState({ modalError: error, modalLoading: false });
      });
  }

  getNext() {
    switch (this.state.data.status.programStatus.keyConstant) {
      case 11:
        return 10
    }
    return 0;
  }

  checkForm(target) {
    for (var i in target)
      if (target[i] == null) return false;
    return true;
  }
  updateForm(target, value) {
    this.state.form[target] = value;
    this.setState({ form: this.state.form });
  }

  openModal(target, props) {
    var v = {};
    props = typeof props === "object" && props != null ? props : {};
    props.isModalVisible = target;
    props.modalInitializing = false;
    props.modalLoading = false;
    props.form = {}
    props.modalError = null;
    this.setState(props);
  }


  addNewFile() {
    this.setState({ modalLoading: true });

    var data = new FormData();

    data.append('data', JSON.stringify(this.state.form));
    data.append('target', this.data.action);
    data.append('file', this.state.file.files[0]);
    data.append('observation', this.state.observation);

    Connection.Secure(Connection.service +
      "Program/" + this.data.id + "/Client/" + this.data.goal + "/Award/Action/File",
      {
        "method": "POST",
        body: data
      })
      .then((response) => {
        if (response.ok && response.status == 200)
          response.json().then(t => {
            this.setState({ modalLoading: false, isModalVisible: null }, () => this.props.history.push('/Program/Detail/' + this.data.id + '/Goal/' + this.data.goal + '/ActionPlan/' + this.data.action + '/Invoice/' + t.id));
          });
        else this.setState({ modalError: response, modalLoading: false });
      })
      .catch((error) => {
        this.setState({ modalError: error, modalLoading: false });
      });
  }

  changeStatus() {
    this.setState({ modalLoading: true });
    Connection.Secure(Connection.service + 'Program/' + this.data.id + "/Client/" +
      this.data.goal + "/Award/Action/" + this.data.action + "/Status",
      {
        "method": "PUT",
        "headers": {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ programStatus: { keyConstant: this.state.nextstatus }, observation: typeof this.state.form.observation === "string" ? this.state.form.observation : null })
      })
      .then((response) => {
        if (response.ok && response.status == 200)
          response.json().then(t => this.setState({ modalLoading: false, isModalVisible: null, status: t }));

        else this.setState({ modalError: response, modalLoading: false });
      })
      .catch((error) => {
        this.setState({ modalError: error, modalLoading: false });
      });
  }

  render() {
    return (
      <Container context={this.constructor}>

        {
          this.state.error != null ? <ErrorComponent error={this.state.error} /> :
            this.state.loading ? <div>{Labels.GetLabel("generic.loading")}</div> :
              <div className="generics_panels" style={{ flexDirection: "column" }}>
                <div style={{ flex: 1 }}>
                  <div className="generics_panels_header"><FontAwesomeIcon icon={this.constructor.PageInfo.icon} /> <span> {Labels.GetLabel(this.constructor.PageInfo.name)} </span>
                    <div style={{ fontSize: 25 }}>{this.state.data.label}</div>
                  </div>

                  <div className="generics_status_bar" style={{ color: Parsers.GetStatusColor(this.state.status.programStatus.keyConstant) }}>
                    <div className="generics_status_bar_title">
                      <FontAwesomeIcon icon={Parsers.GetStatusIcon(this.state.status.programStatus.keyConstant)} className="generics_listing_item_icon" style={{ opacity: 1 }} />
                      {Labels.GetLabel("STATUS_PROGRAM_REFUND." + this.state.status.programStatus.keyConstant)}
                    </div>
                    <div className="generic_status_author">{Parsers.parseUpperCase(GenericHelper.parseInformation(this.state.status.mainPerson.personValue, 1, "valueType"))} - ({Parsers.parseDate(this.state.status.datetimeRegister, "time")})</div>
                    <div className="generics_status_bar_desc">{Labels.GetLabel("ACTION_PLAN_STATUS_PROGRAM_DESC." + this.state.status.programStatus.keyConstant)}</div>
                    {
                      typeof this.state.status.observation === "string" && this.state.status.observation.length > 0 ?
                        <div className="generics_status_bar_desc">
                          <div style={{ marginBottom: 10, fontWeight: "bold" }}>{Labels.GetLabel("generic.observation")}:</div>
                          {this.state.status.observation}
                        </div>
                        : null
                    }
                    {
                      Parsers.parsePermission2(["ACTION_PLAN_APPROVE", "ACTION_PLAN_DECLINE"]) && (this.state.status.programStatus.keyConstant == 4) ?

                        <div style={{ textAlign: "right", marginTop: 20 }}>
                          {
                            Parsers.parsePermission2(["ACTION_PLAN_DECLINE"]) ?
                              <Button variant="danger" disabled={this.state.changed} style={{ marginRight: 10 }} onClick={() => this.openModal("changestatus", { nextstatus: 9 })}>
                                {Labels.GetLabel("REFUND_STATUS_PROGRAM_ACTION_B." + this.state.status.programStatus.keyConstant)}
                              </Button>
                              : null
                          }
                          {
                            Parsers.parsePermission2(["ACTION_PLAN_APPROVE"]) ?
                              <Button variant="success" disabled={this.state.changed} style={{ marginRight: 10 }} onClick={() => this.openModal("changestatus", { nextstatus: 10 })}>
                                {Labels.GetLabel("REFUND_STATUS_PROGRAM_ACTION_A." + this.state.status.programStatus.keyConstant)}
                              </Button>
                              : null
                          }
                        </div>
                        :
                        Parsers.parsePermission2(["ACTION_PLAN_CREATION", "ACTION_PLAN_EDIT"]) && (this.state.status.programStatus.keyConstant == 1 || this.state.status.programStatus.keyConstant == 2) ?

                          <div style={{ textAlign: "right", marginTop: 20 }}>
                            <Button variant="success" disabled={this.state.changed} style={{ marginRight: 10 }} onClick={() => this.openModal("changestatus", { nextstatus: 4 })}>
                              {Labels.GetLabel("REFUND_STATUS_PROGRAM_ACTION_A." + this.state.status.programStatus.keyConstant)}
                            </Button>
                          </div>
                          :
                          Parsers.parsePermission2(["ACTION_PLAN_CREATION", "ACTION_PLAN_EDIT"]) && (this.state.status.programStatus.keyConstant == 9) ?

                            <div style={{ textAlign: "right", marginTop: 20 }}>
                              <Button variant="success" disabled={this.state.changed} style={{ marginRight: 10 }} onClick={() => this.openModal("info")}>
                                {Labels.GetLabel("program.edit")}
                              </Button>
                            </div>
                            : null
                    }

                  </div>

                  <div style={{ padding: 20 }}>
                    <div className="generics_infobox">
                      <div className="generics_infobox_label">{Labels.GetLabel("program.program")}</div>
                      <div className="generics_infobox_value">{this.state.data.qualitativeAward.purchasingGoal.program.label}</div>
                    </div>
                    <div className="generics_infobox">
                      <div className="generics_infobox_label">{Labels.GetLabel("generic.brand")}</div>
                      <div className="generics_infobox_value">{this.state.data.qualitativeAward.purchasingGoal.program.brand.label}</div>
                    </div>
                    <div style={{ clear: "both" }}></div>
                    <div className="generics_infobox">
                      <div className="generics_infobox_label">{Labels.GetLabel("program_refund.unity")}</div>
                      <div className="generics_infobox_value">{Parsers.parseNumber(this.state.data.amount)}</div>
                    </div>
                    <div className="generics_infobox">
                      <div className="generics_infobox_label">{Labels.GetLabel("program_refund.unityvalue")}</div>
                      <div className="generics_infobox_value">{Parsers.parseMoney(this.state.data.valueUnitary)}</div>
                    </div>
                    <div className="generics_infobox">
                      <div className="generics_infobox_label">{Labels.GetLabel("program_refund.ValueTotal")}</div>
                      <div className="generics_infobox_value">{Parsers.parseMoney(this.state.data.valueTotal)}</div>
                    </div>
                    <div style={{ clear: "both" }}></div>
                    <br />
                    <div className="generic_section_header">{Labels.GetLabel("program.fundsused")}
                      {
                        this.state.status.programStatus.keyConstant != 10 || !Parsers.parsePermission2(["INVOICE_CREATION"]) ? null :
                          <div className="generic_section_header_action" onClick={() => this.openModal("file")}><FontAwesomeIcon icon="plus" /></div>
                      }</div>

                    {
                      this.state.data.qaActionPlanInvoice == null ||
                        this.state.data.qaActionPlanInvoice.length == 0 ? <div className="generic_empty">{Labels.GetLabel('program_refund.emptyinvoice')}</div> :
                        this.state.data.qaActionPlanInvoice.map((item2) => {
                          return <div className="generics_listing_item" style={{ display: "block" }}>
                            <div style={{ float: "left" }}>
                              <Link to={"/Program/Detail/" + this.data.id + "/Goal/" + this.data.goal + "/ActionPlan/" + this.data.action + "/Invoice/" + item2.id} className="program_item">
                                <FontAwesomeIcon icon={Parsers.GetStatusIcon(item2.qaApInvoiceStatusElement[0].programStatus.keyConstant)} className="generics_listing_item_icon" style={{
                                  opacity: 1, color: Parsers.GetStatusColor(item2.qaApInvoiceStatusElement[0].programStatus.keyConstant, "invoice")
                                }} />
                                <div className="generics_listing_item_title" style={{ color: Parsers.GetStatusColor(item2.qaApInvoiceStatusElement[0].programStatus.keyConstant, "invoice") }}>{item2.invoice.title}</div>
                              </Link>
                            </div>
                            <div style={{ float: "right", marginTop: 10, marginRight: 10, fontSize: 18 }}>{Parsers.parseMoney(item2.invoice.valueTotal)}</div>
                            <div style={{ clear: "both" }}></div>
                            <div style={{ fontSize: 12, textAlign: "right", marginRight: 10, marginBottom: 10, color: Parsers.GetStatusColor(item2.qaApInvoiceStatusElement[0].programStatus.keyConstant, "invoice") }}>{Labels.GetLabel("STATUS_PROGRAM_REFUND." + item2.qaApInvoiceStatusElement[0].programStatus.keyConstant)}</div>
                          </div>;
                        })}
                    <br />
                    <br />
                  </div>
                </div>

                <div className="generics_actionbar">
                  {!Parsers.parsePermission2(["ACTION_PLAN_EDIT"]) ? null : <DropdownButton
                    as={ButtonGroup}
                    key="up"
                    drop="up"
                    variant="primary" style={{ marginRight: 10 }}
                    title={Labels.GetLabel("program.edit")}
                    onSelect={(t) => this.openModal(t)}
                  >
                    <Dropdown.Item eventKey="info" disabled={!(this.state.status.programStatus.keyConstant == 1 || this.state.status.programStatus.keyConstant == 2 || this.state.status.programStatus.keyConstant == 3 || this.state.status.programStatus.keyConstant == 9)} >{Labels.GetLabel("program.info")}</Dropdown.Item>
                  </DropdownButton>}
                  <Button variant="primary" style={{ marginRight: 10 }} onClick={() => this.openModal("history")}>
                    {Labels.GetLabel("generic.history")}
                  </Button>
                  <div style={{ flex: 1 }}></div>
                  {
                    !Parsers.parsePermission2(["INVOICE_CREATION"]) ? null :
                      <Button variant="info" disabled={this.state.status.programStatus.keyConstant != 10} style={{ marginRight: 10 }} onClick={() => this.openModal("file")}>
                        {Labels.GetLabel("program.refund")}
                      </Button>
                  }
                  <div style={{ clear: "both" }}></div>
                </div>
                <Modal
                  className={this.state.modalLoading == true ? "modal-loading" : ""}
                  onHide={() => { }} show={this.state.isModalVisible != null} >
                  <div>
                    {
                      this.state.modalInitializing == true || this.state.data == null || this.state.isModalVisible == null ?
                        <div>
                          {Labels.GetLabel("adminstategroup.saving")}
                        </div>
                        : this.state.isModalVisible == "history" ?
                          <div>
                            <Modal.Header>
                              <Modal.Title>{Labels.GetLabel("generic.history")}</Modal.Title>
                            </Modal.Header>
                            <Modal.Body>
                              {
                                this.state.data.qaActionPlanStatusElement.map(t =>
                                  <div className="generics_status_bar" style={{ color: Parsers.GetStatusColor(t.programStatus.keyConstant) }}>
                                    <div className="generics_status_bar_title">
                                      <FontAwesomeIcon icon={Parsers.GetStatusIcon(t.programStatus.keyConstant)} className="generics_listing_item_icon" style={{ opacity: 1 }} />{Labels.GetLabel("STATUS_PROGRAM_REFUND." + t.programStatus.keyConstant)}
                                    </div>
                                    <div className="generic_status_author">{Parsers.parseUpperCase(GenericHelper.parseInformation(t.mainPerson.personValue, 1, "valueType"))} - ({Parsers.parseDate(t.datetimeRegister)})</div>
                                  </div>)
                              }
                            </Modal.Body>
                            <Modal.Footer>
                              <Button variant="secondary" onClick={() => this.setState({ isModalVisible: null })}>
                                {Labels.GetLabel("adminstategroup.closebtn")}
                              </Button>
                            </Modal.Footer><div className="modal-loader"><FontAwesomeIcon icon="cog" />{Labels.GetLabel("generic.loading")}</div>
                          </div>
                          :
                          this.state.isModalVisible == "info" ?
                            <div>
                              <Modal.Header>
                                <Modal.Title>{Labels.GetLabel("program.info")}</Modal.Title>
                              </Modal.Header>
                              <Modal.Body>
                                <div style={{ fontWeight: "bold" }}>{Labels.GetLabel("program_refund.investmenttotal")}</div>
                                <div style={{ fontSize: 20 }}>{Parsers.parseMoney(this.state.data.qualitativeAward.maximumInvestment)}</div>
                                <br />
                                <div style={{ fontWeight: "bold" }}>{Labels.GetLabel("program_refund.investmentused")}</div>
                                <div style={{ fontSize: 20 }}>{Parsers.parseMoney(this.state.data.qualitativeAward.totalInvestment)}</div>
                                <br />
                                <div style={{ fontWeight: "bold" }}>{Labels.GetLabel("program_refund.investmentavailable")}</div>
                                <div style={{ fontSize: 20 }}>{Parsers.parseMoney(this.state.data.qualitativeAward.maximumInvestment - this.state.data.qualitativeAward.totalInvestment)}</div>
                                <br />
                                <MaskedInput type="text" value={this.state.data.label} notnull={true} label={Labels.GetLabel("program.action")} onValid={(value) => this.updateForm("label", value)}
                                  onInvalid={(value) => this.updateForm("label", null)} />
                                <MaskedInput type="int" value={this.state.data.amount} notnull={true} label={Labels.GetLabel("program.quantity")} onValid={(value) => this.updateForm("amount", Parsers.normalizeNumber(value))}
                                  onInvalid={(value) => this.updateForm("amount", null)} />
                                <MaskedInput type="decimal" value={this.state.data.valueUnitary} notnull={true} label={Labels.GetLabel("program.uvalue")} onValid={(value) => this.updateForm("valueUnitary", Parsers.normalizeNumber(value))}
                                  onInvalid={(value) => this.updateForm("valueUnitary", null)} />
                                <MaskedInput type="date" value={(() => {
                                  if (typeof this.state.data.dateEvent === "string" && this.state.data.dateEvent.length > 0) {
                                    var v = this.state.data.dateEvent.split("T")[0].split("-");
                                    return Parsers.parseDoubleDigit(v[2]) + "/" + Parsers.parseDoubleDigit(v[1]) + "/" + Parsers.parseDoubleDigit(v[0]);
                                  }
                                  return null;
                                })()} notnull={true} label={Labels.GetLabel("program.evdate")} onValid={(value) => this.updateForm("dateEvent", this.parseDate(value))}
                                  onInvalid={(value) => this.updateForm("dateEvent", null)} />
                              </Modal.Body>
                              <Modal.Footer>
                                <Button variant="secondary" onClick={() => this.setState({ isModalVisible: null })}>
                                  {Labels.GetLabel("adminstategroup.closebtn")}
                                </Button>
                                <Button variant="primary" disabled={!this.checkForm(this.state.form)} onClick={() => this.saveGoal(this.state.form)}>
                                  {Labels.GetLabel("adminstategroup.savebtn")}
                                </Button>
                              </Modal.Footer><div className="modal-loader"><FontAwesomeIcon icon="cog" />{Labels.GetLabel("generic.loading")}</div>
                            </div>
                            :
                            this.state.isModalVisible == "award" ?
                              <div>
                                <Modal.Header>
                                  <Modal.Title>{Labels.GetLabel("program.qualitativeaward")}</Modal.Title>
                                </Modal.Header>
                                <Modal.Body>
                                  {this.state.qualitativeAward != null ? Labels.GetLabel("programgoal.removeaward") : Labels.GetLabel("programgoal.newaward")}
                                </Modal.Body>
                                <Modal.Footer>
                                  <Button variant="secondary" onClick={() => this.setState({ isModalVisible: null })}>
                                    {Labels.GetLabel("adminstategroup.closebtn")}
                                  </Button>
                                  <Button variant="primary" onClick={() => this.state.qualitativeAward != null ? this.RemoveAwardProgram() : this.includeInProgram()}>
                                    {Labels.GetLabel("adminstategroup.savebtn")}
                                  </Button>
                                </Modal.Footer><div className="modal-loader"><FontAwesomeIcon icon="cog" />{Labels.GetLabel("generic.loading")}</div>
                              </div>
                              : this.state.isModalVisible == "file" ?
                                <div>
                                  <Modal.Header>
                                    <Modal.Title>{Labels.GetLabel("program.refund")}</Modal.Title>
                                  </Modal.Header>
                                  <Modal.Body>
                                    <MaskedInput type="text" notnull={true} onValid={(value) => this.updateForm("title", value)} label={Labels.GetLabel("program_refund.Title")}
                                      onInvalid={(value) => this.updateForm("title", null)} />
                                    <div style={{ display: "flex" }}>
                                      <div style={{ flex: 1 }}>
                                        <MaskedInput type="select" data={["NOTA_FISCAL", "CUPOM_FISCAL", "RECIBO_PAPEL"]} parser={t => Labels.GetLabel("invoice_type." + t)} notnull={true} onValid={(value) => this.updateForm("invoiceType", { KeyRegister: value[0] })} label={Labels.GetLabel("program_refund.InvoiceType")}
                                          onInvalid={(value) => this.updateForm("invoiceType", null)} placeholder={Labels.GetLabel("generic.select")} />
                                      </div>
                                      <div style={{ flex: 1, marginLeft: 10 }}>
                                        <MaskedInput type="text" notnull={true} onValid={(value) => this.updateForm("indentificator", value)} label={Labels.GetLabel("program_refund.Indentificator")}
                                          onInvalid={(value) => this.updateForm("indentificator", null)} />
                                      </div>
                                    </div>
                                    <div style={{ display: "flex" }}>
                                      <div style={{ flex: 1 }}>
                                        <MaskedInput type="select" name="keyConstant,label" data={[{ keyConstant: 2, label: "DOC_CNPJ" }, { keyConstant: 1, label: "DOC_CPF" }]} notnull={true} onValid={(value) => this.updateForm("mainKeyCriticalType", { keyConstant: parseInt(value[0]) })} label={Labels.GetLabel("program_refund.MainKeyCriticalType")}
                                          onInvalid={(value) => this.updateForm("mainKeyCriticalType", null)} placeholder={Labels.GetLabel("generic.select")} parser={(t) => Labels.GetLabel("information." + t)} />
                                      </div>
                                      <div style={{ flex: 1, marginLeft: 10 }}>
                                        {
                                          ((t) => {
                                            return t == 2 ?
                                              <MaskedInput key={2} type="cnpj" value={null} notnull={true} onValid={(value) => this.updateForm("criticalValue", value)} label={Labels.GetLabel("program_refund.criticalValue")}
                                                onInvalid={(value) => this.updateForm("criticalValue", null)} /> :
                                              <MaskedInput key={1} type="cpf" value={null} notnull={true} onValid={(value) => this.updateForm("criticalValue", value)} label={Labels.GetLabel("program_refund.criticalValue")}
                                                onInvalid={(value) => this.updateForm("criticalValue", null)} />
                                          })(this.state.form.mainKeyCriticalType == null ? 2 : this.state.form.mainKeyCriticalType.keyConstant)
                                        }
                                      </div>
                                    </div>
                                    <div style={{ display: "flex" }}>
                                      <div style={{ flex: 1 }}>
                                        <MaskedInput type="date" notnull={true} onValid={(value) => this.updateForm("datetimeEmission", this.parseDate(value))} label={Labels.GetLabel("program_refund.DatetimeEmission")}
                                          onInvalid={(value) => this.updateForm("datetimeEmission", null)} />
                                      </div>
                                      <div style={{ flex: 1, marginLeft: 10 }}>
                                        <MaskedInput type="text" notnull={true} onValid={(value) => this.updateForm("issuer", value)} label={Labels.GetLabel("program_refund.Issuer")}
                                          onInvalid={(value) => this.updateForm("issuer", null)} />
                                      </div>
                                    </div>
                                    <div style={{ display: "flex" }}>
                                      <div style={{ flex: 1 }}>
                                        <MaskedInput type="text" notnull={true} onValid={(value) => this.updateForm("kind", value)} label={Labels.GetLabel("program_refund.Kind")}
                                          onInvalid={(value) => this.updateForm("kind", null)} />
                                      </div>
                                      <div style={{ flex: 1, marginLeft: 10 }}>
                                        <MaskedInput type="text" notnull={true} onValid={(value) => this.updateForm("series", value)} label={Labels.GetLabel("program_refund.Series")}
                                          onInvalid={(value) => this.updateForm("series", null)} />
                                      </div>
                                    </div>
                                    <MaskedInput type="decimal" notnull={true} onValid={(value) => this.updateForm("valueTotal", Parsers.normalizeNumber(value))} label={Labels.GetLabel("program_refund.ValueTotal")}
                                      onInvalid={(value) => this.updateForm("valueTotal", null)} />
                                    <br />
                                    <MaskedInput type="text" notnull={true} onValid={(value) => this.setState({ observation: value })} label={Labels.GetLabel("program_refund.Obs")}
                                      onInvalid={(value) => this.setState({ observation: null })} />
                                    <br />
                                    <Form.Label>{Labels.GetLabel("program_refund.file")}</Form.Label>
                                    <Form.File id="exampleFormControlFile1" onChange={t => this.setState({ file: t.target })} />
                                    <br />
                                  </Modal.Body>
                                  <Modal.Footer>
                                    <Button variant="secondary" onClick={() => this.setState({ isModalVisible: null })}>
                                      {Labels.GetLabel("adminstategroup.closebtn")}
                                    </Button>
                                    <Button variant="primary" disabled={this.state.observation == null || this.state.file == null || !this.checkForm(this.state.form)} onClick={() => this.addNewFile()}>
                                      {Labels.GetLabel("adminstategroup.savebtn")}
                                    </Button>
                                  </Modal.Footer><div className="modal-loader"><FontAwesomeIcon icon="cog" />{Labels.GetLabel("generic.loading")}</div>
                                </div>
                                :
                                this.state.isModalVisible == "changestatus" ?
                                  < div >
                                    <Modal.Header>
                                      <Modal.Title>{Labels.GetLabel("program.alterstatus")}</Modal.Title>
                                    </Modal.Header>
                                    <Modal.Body>
                                      {Labels.GetLabel("ACTION_PLAN_STATUS_PROGRAM_WARNING." + (this.state.nextstatus))}
                                      <br />
                                      <br />
                                      <br />
                                      {
                                        this.state.nextstatus == 9 ?
                                          <MaskedInput type="text" label={Labels.GetLabel("generic.observation")} notnull={true}
                                            onValid={(value) => this.updateForm("observation", (value))}
                                            onInvalid={(value) => this.updateForm("observation", null)} />
                                          : null
                                      }
                                    </Modal.Body>
                                    <Modal.Footer>
                                      <Button variant="secondary" onClick={() => this.setState({ isModalVisible: null })}>
                                        {Labels.GetLabel("adminstategroup.closebtn")}
                                      </Button>
                                      <Button variant="primary"
                                        disabled={!this.checkForm(this.state.form)}
                                        onClick={() => this.changeStatus()}>
                                        {Labels.GetLabel("generic.confirm")}
                                      </Button>
                                    </Modal.Footer><div className="modal-loader"><FontAwesomeIcon icon="cog" />{Labels.GetLabel("generic.loading")}</div>
                                  </div>
                                  :
                                  <div>
                                    <Modal.Header>
                                      <Modal.Title>{Labels.GetLabel("clientsnew.franchiseeHeader")}</Modal.Title>
                                    </Modal.Header>
                                    <Modal.Body>
                                      {Labels.GetLabel("clientsnew.confirmation")}
                                    </Modal.Body>
                                    <Modal.Footer>
                                      <Button variant="secondary" onClick={() => this.setState({ isModalVisible: null })}>
                                        {Labels.GetLabel("adminstategroup.closebtn")}
                                      </Button>
                                      <Button variant="primary" onClick={() => this.addNew()}>
                                        {Labels.GetLabel("adminstategroup.savebtn")}
                                      </Button>
                                    </Modal.Footer><div className="modal-loader"><FontAwesomeIcon icon="cog" />{Labels.GetLabel("generic.loading")}</div>
                                  </div>
                    }
                  </div>
                </Modal>
              </div>
        }
      </Container >
    );
  }
} 